/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

const AGENDA_BASE_LINK = '/admin/agenda'

export function getAgendaLink () {
  return AGENDA_BASE_LINK
}
